import { Link } from "react-router-dom";
import { imgSrc } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export const Logo = ({ className = "h-14 sm:h-16", testId = "store-logo" }) => {
  const { settings } = useStore();
  const name = settings?.store_name || "Ceviz Ticaret";
  return (
    <Link to="/" data-testid={testId} className="flex flex-none items-center transition-transform duration-300 hover:-rotate-2 hover:scale-105">
      <img src={settings?.logo_path ? imgSrc(settings.logo_path) : "/img/logo-sm.webp"} alt={name} className={`${className} w-auto object-contain drop-shadow-[0_4px_10px_rgba(42,29,22,0.18)]`} />
    </Link>
  );
};
